__turbopack_context__.v({
  "beamSlide": "Separator-module__vt7-Pq__beamSlide",
  "container": "Separator-module__vt7-Pq__container",
  "dot": "Separator-module__vt7-Pq__dot",
  "dotPulse": "Separator-module__vt7-Pq__dotPulse",
  "left": "Separator-module__vt7-Pq__left",
  "line": "Separator-module__vt7-Pq__line",
  "right": "Separator-module__vt7-Pq__right",
});
